var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormBuilder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 140.61 100.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 140.61,
    height: 100.54
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23127"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15851",
    className: "cls-3",
    d: "m140.6,7.87c-.02-4.34-3.53-7.85-7.87-7.87H7.9C3.55,0,.02,3.52,0,7.87v14.15h140.6V7.87ZM18,13.48h0c-.52.53-1.23.82-1.97.82-1.54.02-2.8-1.22-2.81-2.76v-.06c0-.74.29-1.46.81-1.99,1.13-1.04,2.87-1.04,3.99,0,1.09,1.11,1.09,2.89-.02,3.98,0,0,0,0,0,0m14.05,0c-1.1,1.1-2.89,1.1-3.99,0s-1.1-2.89,0-3.99c1.1-1.1,2.88-1.1,3.98,0,.54.52.84,1.24.84,1.99,0,.75-.31,1.47-.84,2h0Zm14.07,0h0c-.52.53-1.23.82-1.97.82-1.54.02-2.8-1.22-2.81-2.76v-.06c0-.74.29-1.46.82-1.99,1.13-1.04,2.87-1.04,3.99,0,1.09,1.11,1.09,2.89-.02,3.98,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15852",
    className: "cls-3",
    d: "m0,27.64v64.99c0,4.36,3.53,7.9,7.89,7.9h124.84c4.35-.02,7.87-3.55,7.87-7.9V27.64H0Zm36.82,51.11c-9.58.02-17.37-7.74-17.39-17.32-.02-9.58,7.74-17.37,17.32-17.39,3.14,0,6.22.84,8.91,2.44l-8.84,14.92,17.03-3.3c1.83,9.39-4.29,18.49-13.69,20.33-1.1.22-2.22.32-3.35.32m81.53-.77h-39.48c-1.33,0-2.41-1.08-2.41-2.41s1.08-2.41,2.41-2.41h39.47c1.33,0,2.41,1.08,2.41,2.41s-1.08,2.41-2.41,2.41m0-14.53h-39.47c-1.33-.03-2.38-1.13-2.36-2.45.03-1.29,1.07-2.33,2.36-2.36h39.47c1.33.03,2.38,1.13,2.36,2.45-.03,1.29-1.07,2.33-2.36,2.36m0-14.53h-39.47c-1.33-.03-2.38-1.13-2.36-2.45.03-1.29,1.07-2.33,2.36-2.36h39.47c1.33.03,2.38,1.13,2.36,2.45-.03,1.29-1.07,2.33-2.36,2.36"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormBuilder);
export default __webpack_public_path__ + "static/media/FormBuilder.e6f0e1d3eb27490033f5f77e3f8d05b9.svg";
export { ForwardRef as ReactComponent };